var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBirthday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.75 60.125h52.5",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10 36h44v14h-44z",
    fill: "#ffdd6a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10 27h44v10 2h-.6689c-.8645 1.1956-2.4804 2-4.3311 2s-3.4666-.8044-4.3311-2h-2.3378c-.8645 1.1956-2.4804 2-4.3311 2s-3.4666-.8044-4.3311-2h-3.3378c-.8645 1.1956-2.4804 2-4.3311 2s-3.4666-.8044-4.3311-2h-2.3378c-.8645 1.1956-2.4804 2-4.3311 2s-3.4666-.8044-4.3311-2h-.6689v-2z",
    fill: "#ffab00",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10 27h44v10 2h-.6689c-.8645 1.1956-2.4804 2-4.3311 2s-3.4666-.8044-4.3311-2h-2.3378c-.8645 1.1956-2.4804 2-4.3311 2s-3.4666-.8044-4.3311-2h-3.3378c-.8645 1.1956-2.4804 2-4.3311 2s-3.4666-.8044-4.3311-2h-2.3378c-.8645 1.1956-2.4804 2-4.3311 2s-3.4666-.8044-4.3311-2h-.6689v-2z",
    fill: "#ffab00",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.25 26.375h37.5s3.75 0 3.75 3.75v16.25s0 3.75-3.75 3.75h-37.5s-3.75 0-3.75-3.75v-16.25s0-3.75 3.75-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 20.75v5.625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.75 9.5c0 .9946-.3951 1.9484-1.0984 2.6517-.7032.7032-1.657 1.0983-2.6516 1.0983s-1.9484-.3951-2.6517-1.0983c-.7032-.7033-1.0983-1.6571-1.0983-2.6517 0-2.075 3.75-5.625 3.75-5.625s3.75 3.55 3.75 5.625z",
    fill: "#fb5f3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 20.75v5.625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.75 9.5c0 .9946-.3951 1.9484-1.0984 2.6517-.7032.7032-1.657 1.0983-2.6516 1.0983s-1.9484-.3951-2.6516-1.0983c-.7033-.7033-1.0984-1.6571-1.0984-2.6517 0-2.075 3.75-5.625 3.75-5.625s3.75 3.55 3.75 5.625z",
    fill: "#fb5f3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 20.75v5.625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.75 9.5c0 .9946-.3951 1.9484-1.0983 2.6517-.7033.7032-1.6571 1.0983-2.6517 1.0983s-1.9484-.3951-2.6517-1.0983c-.7032-.7033-1.0983-1.6571-1.0983-2.6517 0-2.075 3.75-5.625 3.75-5.625s3.75 3.55 3.75 5.625z",
    fill: "#fb5f3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.5 37.55c.5761.9799 1.3981 1.7923 2.3847 2.3568.9867.5644 2.1036.8614 3.2403.8614s2.2536-.297 3.2403-.8614c.9866-.5645 1.8086-1.3769 2.3847-2.3568.5761.9799 1.3981 1.7923 2.3847 2.3568.9867.5644 2.1036.8614 3.2403.8614s2.2536-.297 3.2403-.8614c.9866-.5645 1.8086-1.3769 2.3847-2.3568.5761.9799 1.3981 1.7923 2.3847 2.3568.9867.5644 2.1036.8614 3.2403.8614s2.2536-.297 3.2403-.8614c.9866-.5645 1.8086-1.3769 2.3847-2.3568.5761.9799 1.3981 1.7923 2.3847 2.3568.9867.5644 2.1036.8614 3.2403.8614s2.2536-.297 3.2403-.8614c.9866-.5645 1.8086-1.3769 2.3847-2.3568"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBirthday);
export default __webpack_public_path__ + "static/media/icon-birthday.741aa22319cc4fe500910c0ec1656724.svg";
export { ForwardRef as ReactComponent };